export const encodeUrlObject = (data: Record<string, string>): string => {
  // Need to use atob and btoa here because the browser does not have the Buffer API
  return encodeURIComponent(btoa(JSON.stringify(data)));
};

export const decodeUrlObject = (data: string): Record<string, string> => {
  return JSON.parse(atob(decodeURIComponent(data)));
};
